"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const SingleReportController_1 = __importDefault(require("@becrop/components/Results/Abstract/Controllers/SingleReportController"));
const v_calendar_1 = require("v-calendar");
const moment_1 = __importDefault(require("moment"));
let ModalEditionReports = class ModalEditionReports extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.currentReport = this.editedReport;
        this.changedReport = this.editedReport;
        this.isFetchingLoadingActive = true;
        this.isSavingToastActive = false;
        this.isSaveButtonDisabled = true;
        this.isSaveButtonLoading = false;
        this.isSavedSuccessful = false;
        this.toastMainMessage = '';
        this.toastErrors = [];
        this.singleReportService = new SingleReportController_1.default(this.currentReport);
        this.artPracs = 'yes';
        this.orgPracs = 'yes';
        this.biodynPracs = 'yes';
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get soilTypeOptions() {
        const soilTypes = this.singleReportService.soilTypes;
        return soilTypes.map((s) => {
            return {
                'label': s.name,
                'value': s.id
            };
        });
    }
    async fetchReportData() {
        this.isFetchingLoadingActive = true;
        await this.singleReportService.fetchData();
        this.isFetchingLoadingActive = false;
    }
    dismissEditionModal() {
        this.$emit('dismisseditionmodal');
    }
    dismissToast() {
        this.isSavingToastActive = false;
    }
    triggerChange() {
        this.isSaveButtonDisabled = false;
    }
    triggerClientReference(s) {
        this.triggerChange();
        this.changedReport.client_reference = s;
    }
    triggerFecha(s) {
        this.triggerChange();
        this.changedReport.fecha_muestra = s;
    }
    triggerPlant(s) {
        this.triggerChange();
        this.changedReport.tierra.plant_year = s;
    }
    triggerVariety(s) {
        this.triggerChange();
        this.changedReport.variety = s;
    }
    triggerCoordinates(s) {
        this.triggerChange();
        const latitude = s.split(" ")[0];
        const longitude = s.split(" ")[1];
        this.changedReport.tierra.latitud = latitude;
        this.changedReport.tierra.longitud = longitude;
    }
    triggerDensity(s) {
        this.triggerChange();
        this.changedReport.tierra.density = s;
    }
    changeArtIrrig(v) {
        this.triggerChange();
        this.changedReport.tierra.art_irrigation = v;
    }
    changeOrgPracs(v) {
        this.triggerChange();
        this.changedReport.tierra.org_practises = v;
    }
    changeBioDyn(v) {
        this.triggerChange();
        this.changedReport.tierra.uses_biodynamic_methods = v;
    }
    changeSoilTexture(v) {
        this.triggerChange();
        this.changedReport.tierra.soil_type_id = v.value;
        this.changedReport.tierra.soiltype = v.label;
    }
    async saveChanges() {
        this.isSaveButtonLoading = true;
        const response = await this.singleReportService.saveUpdatedReport(this.changedReport);
        this.isSavedSuccessful = response.status;
        if (!response.status) {
            response.errors.forEach((e) => {
                this.toastMainMessage += e + '\n';
            });
            this.isSaveButtonDisabled = true;
            this.isSavingToastActive = true;
            this.isSaveButtonLoading = false;
        }
        else {
            this.isSaveButtonDisabled = true;
            this.isSavingToastActive = false;
            this.isSaveButtonLoading = false;
            this.notifySuccessfulEdition();
        }
    }
    notifySuccessfulEdition() {
        this.dismissEditionModal();
        this.$emit('notifysuccessfuledition');
    }
    dateTime(val) {
        let dates = (0, moment_1.default)(val).format('YYYY-MM-DD');
        return dates;
    }
    async mounted() {
        await this.fetchReportData();
        this.artPracs = this.singleReportService.parsedMetadataProps('art_irrigation');
        this.orgPracs = this.singleReportService.parsedMetadataProps('org_practises');
        this.biodynPracs = this.singleReportService.parsedMetadataProps('uses_biodynamic_methods');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], ModalEditionReports.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ModalEditionReports.prototype, "editedReport", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalEditionReports.prototype, "crop", void 0);
ModalEditionReports = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Breadcrumbs: bmk_ui_framework_1.Breadcrumbs,
            BreadcrumbsItem: bmk_ui_framework_1.BreadcrumbsItem,
            Loading: bmk_ui_framework_1.Loading,
            PageHeading: bmk_ui_framework_1.PageHeading,
            ModalFullScreen: bmk_ui_framework_1.ModalFullScreen,
            SelectField: bmk_ui_framework_1.SelectField,
            Select: bmk_ui_framework_1.Select,
            InputField: bmk_ui_framework_1.InputField,
            RadioButtonsSet: bmk_ui_framework_1.RadioButtonsSet,
            RadioButton: bmk_ui_framework_1.RadioButton,
            Button: bmk_ui_framework_1.Button,
            ArrowLeftIcon: bmk_ui_framework_1.ArrowLeftIcon,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            TubeIcon: bmk_ui_framework_1.TubeIcon,
            PencilIcon: bmk_ui_framework_1.PencilIcon,
            Calendar: v_calendar_1.Calendar,
            DatePicker: v_calendar_1.DatePicker,
            Toasts: bmk_ui_framework_1.Toasts
        },
    })
], ModalEditionReports);
exports.default = ModalEditionReports;
